<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="market content-wrapper">
      <div class="page-header">{{ $t('editMarket') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'SettingMarketList' }">{{ $t('market') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editMarket') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 100%; max-width: 800px">
        <el-form-item :label="$t('name')" :required="true">
          <el-input v-model="market.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input type="textarea" v-model="market.detail"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="market.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('agentList')">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="onAddAgentButtonClick"> {{ $t('addAgent') }} </el-button>
        </el-form-item>
        <el-form-item>
          <el-table
            id="market-agent-list-table"
            :data="getAgentListDataSource()"
            :row-class-name="getRowClassName"
            header-row-class-name="table-header-color"
            :default-sort = "{prop: sortKey, order: sortBy}"
            style="width: 100%">
            <el-table-column
              type="index"
              width="50"
              :index="getRowNumber">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('agentName')">
              <template slot-scope="scope">{{ getAgentName(scope.row) }}</template>
            </el-table-column>
            <el-table-column align="right" >
              <template slot-scope="scope">
                <el-button type="danger" size="mini" icon="el-icon-delete" @click="onDeleteAgentButtonClick(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="filterAgent().length"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change = "changePage">
            </el-pagination>
          </div>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="150px" style="width: 100%; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onSaveButtonClick">{{ $t('save') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <popup-agent-list
    :visible="isShowDialog"
    :selected-agent-id-list="selectedAgentIdList"
    :agent-list="agentList"
    @onClose="onClosePopup()"
    @onSaveChange="onPopupSaveAgentList">
    </popup-agent-list>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Setting/ManageSetting/Market/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent'
import SettingMarketApi from '@/api/setting/market-api'
import AgentService from '@/services/agent-service'
import PopupAgentList from './components/PopupAgentList.vue'
import { getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { sortDataList, getStatusName } from '@/helpers'

export default {
  name: 'SettingMarketEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, PopupAgentList },
  i18n: { messages: i18nMessages },
  props: {
    market: {
      type: Object,
      default: () => {
        return {
          name: '',
          detail: '',
          isEnable: STATUS.DISABLE,
          agentIdList: []
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      isShowDialog: false,
      STATUS,
      agentList: [],
      currentPage: 1,
      pageSize: 5,
      sortKey: 'name',
      sortBy: 'ascending',
      selectedAgentIdList: []
    }
  },
  created: async function () {
    this.isLoading = true
    if (this.market.name === '' || this.market.name === undefined) {
      this.$router.push({
        name: 'SettingMarketList'
      })
    }
    try {
      const agentList = await AgentService.getAgentList()
      this.agentList = sortDataList(agentList, this.sortKey, this.sortBy)
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  methods: {
    onSaveButtonClick: async function () {
      try {
        this.startLoading()
        await SettingMarketApi.update(this.market.id, this.market)
        const title = this.$t('editMarketSuccessTitle')
        const message = this.$t('editMarketSuccessMessage')
        this.showNotificationSuccess(title, message)
        this.$router.push({
          name: 'SettingMarketList'
        })
      } catch (err) {
        this.alertError(err.message)
      }
      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'SettingMarketList'
      })
    },
    onAddAgentButtonClick: function () {
      this.selectedAgentIdList = [ ...this.market.agentIdList ]
      this.isShowDialog = true
    },
    onClosePopup: function () {
      this.isShowDialog = false
    },
    onPopupSaveAgentList: function (agentIdList) {
      this.market.agentIdList = [ ...agentIdList ]
    },
    changePage: function (page) {
      this.currentPage = page
    },
    getAgentListDataSource: function () {
      const filteredUserList = this.filterAgent()
      this.currentPage = adjustCurrentPage(filteredUserList.length, this.currentPage, this.pageSize)

      const agentList = getDataOnPaging(filteredUserList, this.currentPage, this.pageSize)
      return agentList
    },
    filterAgent: function () {
      const filteredAgentList = this.agentList.filter((agent) => {
        return (this.market.agentIdList.indexOf(agent.id) > -1)
      })
      return filteredAgentList
    },
    getRowNumber: function (index) {
      const rowOfPage = index + 1
      return rowOfPage + (this.pageSize * (this.currentPage - 1))
    },
    getAgentName: function (agent) {
      if (agent.isEnable === STATUS.DISABLE) {
        return `[${this.$t(getStatusName(STATUS.DISABLE))}] ${agent.name}`
      }

      return agent.name
    },
    getRowClassName: function ({ row, rowIndex }) {
      if (row.isEnable === 1) {
        return ''
      }
      return 'disable-row'
    },
    onDeleteAgentButtonClick: async function (agent) {
      const confirmMessage = this.$t('confirmDeleteAgentMessage')
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      this._deleteAgent(agent)
    },
    _deleteAgent: function (agent) {
      const index = this.market.agentIdList.indexOf(agent.id)
      if (index > -1) {
        this.market.agentIdList.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
